/*global google*/
import React from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MaterialReactTable from 'material-react-table';
import { faArrowLeft, faEye, faImage } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import "../../assets/styles/CropSurveyView.css";


const containerStyle = {
    width: '100%',
    height: '50vh'
};

const center = {
    lat: 28.641832439372656,
    lng: 77.22480777651072
};

   // prod
//    googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE"
   // local
                      //  googleMapsApiKey: "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0",

function CropSurveyView() {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [formsData, setFormsData] = useState([]);
    const [cropSurveyData, setCropSurveyData] = useState([]);
    const [imageData, setImageData] = useState([]);
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
       googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE" 
    })

  
    let imageSrc = [];

    const [map, setMap] = useState(null)
    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "CropSurveyCode": String(state.cropSurveyCode)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancroppingpattern/GetCroppingPatternExtbyCropSurveyCode`, requestOptions)
            .then(response => response.json())
            .then(result => {
                setFormsData(result.dataContent)
            })
            .catch(error => console.log('error', error));

    }, [])

    useEffect(() => {

        axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancropsurvey/getCropSurveyByCropSurveyCode`, {
            "CropSurveyCode": String(state.cropSurveyCode)
        })
        .then((response) => {
            setCropSurveyData(response.data.dataContent);
        });

    }, [])
    const onLoad = React.useCallback(function callback(map) {
        function firstFunction1() {
           
                return new Promise((resolve, reject) => { 
                    const y = axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancropsurveypolygon/getPolygonbyCropSurveyCode`, {
                        "CropSurveyCode": String(state.cropSurveyCode)
                    })
                    resolve(y)

                })
                      
        }
        async function secondFunction1() {
            const result = await firstFunction1()
            var response_value = JSON.stringify(result.data.dataContent)
            let mylocalvalue = JSON.parse(response_value);
            var myFinalArray = [];
            var myInfoWindow = [];
            var myPolygon;
            var myPolygon = [];
            var CropSurveyCode = []
            for (let i = 0; i < mylocalvalue.length; i++) {
                CropSurveyCode.push(JSON.parse(mylocalvalue[i].cropSurveyCode))
                myPolygon[i] = "myPolygon" + [i];
                myFinalArray.push(JSON.parse(mylocalvalue[i].polygonShape))
                myPolygon[i] = new window.google.maps.Polygon({
                    paths: myFinalArray,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.1,
                    content: 'Crop Survey Code ' + CropSurveyCode
                });

                google.maps.Polygon.prototype.my_getBounds=function(){
                    var bounds = new google.maps.LatLngBounds()
                    myPolygon[i].getPath().forEach(function(element,index){bounds.extend(element)})
                    return bounds
                }

                myPolygon[i].setMap(map);
                let newCenter = myPolygon[i].my_getBounds().getCenter();
                map.setCenter(newCenter);
               
                myInfoWindow[i] = new google.maps.InfoWindow;
                myPolygon[i].addListener('mouseover', function (event) {
                    myPolygon[i].setEditable(!myPolygon[i].getEditable());
                    myInfoWindow[i].setContent(this.content);
                    myInfoWindow[i].setPosition(event.latLng);
                    myInfoWindow[i].open(map);
                });
                myPolygon[i].addListener('mouseout', function (event) {
                    myInfoWindow[i].close();
                });
                myFinalArray = [];
                CropSurveyCode = []
            }
        };
        secondFunction1()
    }, [])

    function formatDate(originalRow) {
        var format = originalRow.dateofSowing.split("T")[0]
        console.log("format&&&", format[0], format[1], format[2])
        // return format[0] + "-" + format[1] + "-" + format[2]
        return format
    }

    function formatDateTime(originalRow) {
        let valuess = (originalRow.createModifyByIntUser.createdOnByUC).split("T")
        var format = valuess[0].split("-")
        var formatTime = valuess[1].split(":")
        return format[2] + "-" + format[1] + "-" + format[0] + " "+ formatTime[0] + ":" + formatTime[1]
    }

    function handleImageView(value) {

        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "CropSurveyCode": value.cropSurveyCode,
            "CroppingPatternCode": value.croppingPatternCode
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancropsurveyimage/GetCropSurveyImagebyImagePath`, requestOptions)
            .then(response => response.json())
            .then(result => {
                imageSrc = [];
                setImageData(result);
                result.dataContent.map((item, key) => {
                    imageSrc.push('data:image/png;base64,' + String(item.imageSrcinByte))
                })
                let htmlData = '';

                imageSrc.map((item, key) => {
                    htmlData = htmlData + '<img src=' + item + ' className="img_slide img-fluid"  alt="Farmer Land Image" />'
                })

            //     <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
            //     <div class="carousel-inner">
            //       <div class="carousel-item active">
            //         <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" data-bs-toggle="modal" data-bs-target="#exampleModal" class="d-block w-100" alt="..."/>
            //       </div>
            //       <div class="carousel-item">
            //         <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" data-bs-toggle="modal" data-bs-target="#exampleModal" class="d-block w-100" alt="..."/>
            //       </div>
            //       <div class="carousel-item">
            //         <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" data-bs-toggle="modal" data-bs-target="#exampleModal" class="d-block w-100" alt="..."/>
            //       </div>
            //     </div>
            //     <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
            //       <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            //       <span class="visually-hidden">Previous</span>
            //     </button>
            //     <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
            //       <span class="carousel-control-next-icon" aria-hidden="true"></span>
            //       <span class="visually-hidden">Next</span>
            //     </button>
            //   </div>


                document.getElementById("modal-content").innerHTML = htmlData

             })
            .catch(error => console.log('error', error));

    }

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },

        {
            accessorKey: 'cropName',
            header: 'Crop Name',
        },
        {
                accessorKey: 'cropStageName',
                header: 'Crop Stage',
        },
        {
            accessorKey: 'createModifyByIntUser.createdOnByUC',
            header: 'Survey Date',
        },
        {
            accessorKey: 'cropRatio',
            header: 'Ratio(%)',
        },
        {
            header: 'Date of Sowing',
            accessorFn: (originalRow) => formatDate(originalRow), //alternative to accessorKey, using accessorFn
            id: 'dateofSowing',
        },

        {
            accessorKey: 'croppingPattern',
            header: 'Cropping Pattern',
        },
        {
            accessorKey: 'adversityRemarks',
            header: 'Remarks',
        },
        {
            accessor: '',
            header: 'View Details',
            Cell: cell => <div data-bs-toggle="modal" data-bs-target="#staticBackdrop"> <i><FontAwesomeIcon className="hover" icon={faImage} onClick={() => handleImageView(cell.row.original)} /></i></div>
        },

        ],
        [],
    );

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    function removed() {
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "none";

    }

    return isLoaded ? (
        <>
            {/* <AdminHeader />
            <AdminSideBar /> */}
            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">

                    <nav>
                        <h1>Crop Survey View</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Cropic</li>
                            <li className="breadcrumb-item active">Crop Survey View</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" onClick={() => navigate("/cropic/cropsurveydetails")}><i><FontAwesomeIcon icon={faArrowLeft} /></i> Back</button>
                </div>
                <section className="section">
                    <div className="row">
                        <div className="col-lg-3 dashboard">
                            <div className="card">
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    center={center}
                                    zoom={18}
                                    onLoad={onLoad}
                                    onUnmount={onUnmount}
                                    mapTypeId="satellite"
                                >

                                </GoogleMap>
                            </div>
                        </div>
                        <div className="col-lg-9 dashboard">
                            <div className="card">
                                {cropSurveyData[0] && <div className="card-body">
                                    <div className="row cropview">
                                        <div className="col-md-2">
                                            <h6>User Name</h6>
                                            <p>{cropSurveyData[0].userName}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <h6>Season Name</h6>
                                            <p>{cropSurveyData[0].seasonName}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <h6>IU Name</h6>
                                            <p>{cropSurveyData[0].iuName}</p>
                                        </div>
                                     

                                        <div className="col-md-2">
                                            <h6>CropStage Code</h6>
                                            <p>{cropSurveyData[0].currentCropStageCode}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <h6>Survey No</h6>
                                            <p>{cropSurveyData[0].surveyNo}</p>
                                        </div>
                                    </div>
                                    <div className="row cropview">
                             
                                    </div>

                                </div>}
                            </div>
                            <div className="card">
                                <MaterialReactTable
                                    columns={columns}
                                    data={formsData}
                                    enableColumnOrdering
                                    enablePagination={true}

                                />

                            </div>
                        </div>
                    </div>
                </section>

            </main>

            <div id="mpopupBox" className="modal">

                <div className="modal-content" >
                    <div className="modal-header">
                        <h2>View Details</h2>
                        <button type="button" className="btn-close" onClick={removed}>X</button>
                    </div>
                    <div className="madal-body" id="modal-content" >

                    </div>
                    <div className="modal-footer">
                       
                    </div>
                </div>

            </div>

        </>
    ) : <></>
}

export default React.memo(CropSurveyView)